//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import qs from 'qs'
import dateDiff from '../utils/dateDiff'

const scoreMsgs = ['要吐槽', '一般', '满意', '很满意', '超赞']
export default {
  name: 'm-message',
  props: ['message'],
  mounted: function () {
    const data = {
      'productsCode': this.$route.params.productCode,
      'page.currentPage': ++this.currentPage,
      'page.showCount': 10
    }
    if (this.isWKB()) {
      data['page.showCount'] = 3
      data.isNewComment = true
    }
    if (this.isWKB()) {
      this.$http.get('/api/baokuan/evaluationPage?' + qs.stringify(data)).then(response => {
        if (response.data.page == null) {
          return
        }
        response.data.dataList.forEach((ele) => {
          if (/^1[34578]\d{9}$/.test(ele.utTdnick)) {
            const s1 = ele.utTdnick.substr(0, 3)
            const s2 = ele.utTdnick.substr(8, 4)
            ele.utTdnick = s1 + '****' + s2
          }
          ele.createTime = new Date(ele.createTime)
          ele.scoreMsg = scoreMsgs[ele.score - 1]
          if (ele.utTdavatar == null || ele.utTdavatar === '') {
            ele.utTdavatar = 'static/common/images/avatar.png'
          }
        })
        this.allMessages = response.data.dataList
        this.totalNumber = response.data.page.totalResult
        if (this.totalNumber > 3) {
          this.isShowMore = true
          if (this.totalNumber > 5) {
            let message = {
              isShowSum: true
            }
            if (this.totalNumber < 99) {
              message.totalNumber = this.totalNumber.toString()
            } else {
              message.totalNumber = '99+'
            }
            this.$emit('changeMessage', message)
            this.messagePanel = message
          }
        }
        setTimeout(() => {
          this.$emit('on-messageReady')
        }, 300)
      })
    } else {
      this.$http.get('/api/baokuan/evaluationPage?' + qs.stringify(data)).then(response => {
        this.totalNumber = response.data.page.totalResult
        this.totalPage = Math.ceil(response.data.page.totalResult / 10)
        response.data.dataList.forEach((ele) => {
          if (/^1[34578]\d{9}$/.test(ele.utTdnick)) {
            const s1 = ele.utTdnick.substr(0, 3)
            const s2 = ele.utTdnick.substr(8, 4)
            ele.utTdnick = s1 + '****' + s2
          }
          this.allMessages.push({user: ele.utTdnick, message: ele.ptNotes, date: new Date(ele.createTime)})
        })
        setTimeout(() => {
          this.$emit('on-messageReady')
        }, 300)
      })
    }
  },
  data () {
    return {
      showMoreState: true,
      currentPage: 0,
      totalPage: 0,
      totalNumber: 0,
      allMessages: [],
      isWkbFlag: true,
      isShowMore: false,
      messagePanel: {
        isShowSum: false,
        totalNumber: ''
      }
    }
  },
  computed: {
    messages () {
      this.allMessages.forEach((ele) => {
        if (ele.date != null && typeof ele.date !== 'string') {
          ele.date = dateDiff(ele.date)
        }
        if (ele.createTime != null && typeof ele.createTime !== 'string') {
          ele.createTime = ele.createTime.format('yyyy-MM-dd')
        }
      })
      if (this.showMoreState) {
        return this.allMessages.slice(0, (this.currentPage - 1) * 10 + 4)
      } else {
        return this.allMessages
      }
    },
    moreTips () {
      if (this.showMoreState) {
        return '查看更多(' + (this.totalNumber - (this.currentPage - 1) * 10 - 4) + ')'
      } else {
        return '收起全部'
      }
    },
    goMoreClass () {
      if (['150476691002746473', '150537492578996275', '150572818874302097', '150572806361984311', '150570517523511386', '150546537968917914'].indexOf(this.$store.state.app.productCode) !== -1) {
        return 'goMore_blue'
      } else if (['150459718262681719', '150514806330000319'].indexOf(this.$store.state.app.productCode) !== -1) {
        return 'goMore_red'
      } else if (['150634119420883220', '150631164164706555'].indexOf(this.$store.state.app.productCode) !== -1) {
        return 'goMore_baby_blue'
      } else if (['150831059068987214', '150840325766681140'].indexOf(this.$store.state.app.productCode) !== -1) {
        return 'goMore_orange'
      } else if (['151013300258317638', '151072428587363110'].indexOf(this.$store.state.app.productCode) !== -1) {
        return 'goMore_yellow'
      }
      return 'goMore_orange'
    }
  },
  methods: {
    isWKB () {
      if (['149673178664394306', '148198068433580000'].indexOf(this.$store.state.app.innerCode) === -1) {
        this.isWkbFlag = false
        return false
      }
      return true
    },
    showMore () {
      if (this.currentPage >= this.totalPage && this.showMoreState === true) {
        this.showMoreState = false
        return
      }
      if (this.showMoreState === false) { // 收起
        this.currentPage = 1
        this.allMessages = this.allMessages.slice(0, 10)
        this.showMoreState = true
        return
      }
      const data = {
        'productsCode': this.$route.params.productCode,
        'page.currentPage': ++this.currentPage,
        'page.showCount': 10
      }
      this.$http.get('/api/baokuan/evaluationPage?' + qs.stringify(data)).then(response => {
        response.data.dataList.forEach((ele) => {
          if (/^1[34578]\d{9}$/.test(ele.utTdnick)) {
            const s1 = ele.utTdnick.substr(0, 3)
            const s2 = ele.utTdnick.substr(8, 4)
            ele.utTdnick = s1 + '****' + s2
          }
          this.allMessages.push({user: ele.utTdnick, message: ele.ptNotes, date: new Date(ele.createTime)})
        })
        if (this.messages.length === this.totalNumber) {
          this.showMoreState = false
        }
      })
    },
    goMore () {
      window.location.href = '/products/' + this.$route.params.productCode + '/comments?innerCode=' + this.$store.state.app.innerCode
    }
  },
  filters: {
    scoreImg (score, index) {
      if (!score) return 'static/common/images/star_small.png'
      if (!index) return 'static/common/images/star_small.png'
      if (index > score) {
        return 'static/common/images/no_star_small.png'
      } else {
        return 'static/common/images/star_small.png'
      }
    },
    scoreMsg (score) {
      if (!score) return scoreMsgs[4]
      return scoreMsgs[score - 1]
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Message.vue